import { type StoreType } from '../resiliencedb';

import { MetricsCollector } from './MetricsCollector';
import { type ResilienceMechanism } from './types';

export type MetricsType = {
	eventCount: number;
	failedReclaims: number;
	// Localstorage specific
	fullReclaims: number;
	itemsDiscardedByOverflow: number;

	itemsDiscardedByRetry: number;
	localstorageQueuesPurged: number;
	partialReclaims: number;
	resilienceMechanism: ResilienceMechanism | StoreType;
};

let cachedMetricsClient: MetricsCollector | null = null;

// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
export default (): MetricsCollector => {
	if (!cachedMetricsClient) {
		cachedMetricsClient = new MetricsCollector();
	}
	return cachedMetricsClient;
};
